module.exports = __webpack_public_path__ + "static/impact-webfont-0bea0b0261c41f325068c58c38723ac8.woff";